export type ESRIAddress = {
  address: string;
  attributes: {
    AddNum: string;
    Addr_type: string;
    Address: string;
    AddStreet: string;
    Block: string;
    City: string;
    CntryName: string;
    CountyCode: string;
    District: string;
    LongLabel: string;
    Match_addr: string;
    MetroArea: string;
    Neighborhood: string;
    PlaceName: string;
    Postal: string;
    PostalExt: string;
    Region: string;
    RegionAbbr: string;
    Sector: string;
    ShortLabel: string;
    Subregion: string;
    Territory: string;
    Type: string;
  };
};

export type Coordinate = {
  latitude: number;
  longitude: number;
  accuracy: number | null;
  altitude: number | null;
  datetime: string;
  address?: ESRIAddress;
  captureMethod: LocationCaptureMethod;
};

export enum LocationCaptureMethod {
  Map = 'Map',
  Locator = 'Locator',
  LastKnownLocation = 'LastKnownLocation',
  Imported = 'Imported',
};

export type PostitionCoords = {
  latitude: number;
  longitude: number;
  accuracy?: number;
  altitudeAccuracy?: number | null;
  altitude?: number | null;
  speed?: number | null;
  heading?: number | null;
};

export type Layer = {
  [key: string]: string;
  LayerType: string;
  LayerName: string;
};

export type LocationComponentValue = {
  coordinates: Coordinate[];
  unavailable?: boolean;
  layers?: { [key: string]: Layer }[];
};